export enum USER_STATUS {
	AWAITING = 'AWAITING',
	ACTIVE = 'ACTIVE',
	INACTIVE = 'INACTIVE'
}